import Barcode from 'react-barcode';

interface BoletoProps {
  barcode?: string;
  digitableLine?: string;
  boletoUrl?: string;
}

export function BoletoBarcode({ barcode, digitableLine, boletoUrl }: BoletoProps) {
  if (!barcode && !digitableLine) return null;

  return (
    <div className="space-y-3">
      {barcode && (
        <div className="flex justify-center">
          <Barcode value={barcode} format="ITF" width={1.5} height={50} displayValue={false} />
        </div>
      )}
      {digitableLine && (
        <div className="text-center">
          <p className="font-mono text-sm break-all">{digitableLine}</p>
        </div>
      )}
      {boletoUrl && (
        <div className="text-center">
          <a 
            href={boletoUrl} 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-sm text-blue-600 hover:underline"
          >
            Visualizar Boleto Completo
          </a>
        </div>
      )}
    </div>
  );
}

export default BoletoBarcode;
